<script lang="ts">
  import { cn } from '$lib/utils';

  export let orientation: 'horizontal' | 'vertical' = 'horizontal';
  let className: string | undefined = undefined;
  export { className as class };
</script>

<div
  role="separator"
  class={cn(
    'shrink-0 bg-primary/4',
    orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
    className
  )}
/>
